//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useState, useContext, useEffect } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Autocomplete,
  TextField,
} from '@mui/material';

// === COMPONENTS ===
import { ExpressionContext } from 'pages/DocAnalytics/RuleView/components/ExpressionContext/ExpressionContext';

//#endregion

//-----------------------------------------------------------------
export function DocumentSelect( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { documents } = useContext( ExpressionContext );

  const [ numcode , setNumcode ] = useState( { label: '', numcode: '', name: '' } );

  let numcode_prop = props?.numcode;
  if( !numcode_prop?.startsWith('D') ) numcode_prop = 'D' + numcode_prop;

  //#endregion

  //#region [STYLES]

  const theme = useTheme();
  const _styles = {
    select_doc: {
      width: '100%',
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
  }

  // === ATTRIBUTES

  const SELECT_DOC = {
    sx          : _styles.select_doc,
    id          : 'doc-select',
    options     : documents   ,
    value       : numcode     ,
    size        : 'small',
    freeSolo    : true, 
    onChange    : onChange,
    renderInput : (params) => <TextField {...params} label="Document" />,
    getOptionLabel : (option) => option.label,
    disableClearable : true,
  };
    
  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    setNumcode( documents.find( x=> x.numcode === numcode_prop ) );
  }, [documents, props] ); // empty dependency = called only once at startup

  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function onChange( event, value ) {
    //-----------------------------------------------------------------
    if( props.onChange ) props.onChange( value )
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <>
        <Autocomplete { ...SELECT_DOC } />
      </>
    );
  }

  //#endregion

  return display();
}
